import { render, staticRenderFns } from "./gc-field-checkbox.vue?vue&type=template&id=aa160154"
import script from "./gc-field-checkbox.vue?vue&type=script&lang=js"
export * from "./gc-field-checkbox.vue?vue&type=script&lang=js"
import style0 from "./gc-field-checkbox.vue?vue&type=style&index=0&id=aa160154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports